var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormula = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 2.75a.75.75 0 0 0-.712.513L5.47 10.22 4.205 6.744A.75.75 0 0 0 3.5 6.25H2a.75.75 0 0 0 0 1.5h.975l1.82 5.006a.75.75 0 0 0 1.417-.019L9.04 4.25h4.46a.75.75 0 0 0 0-1.5h-5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.03 7.97a.75.75 0 1 0-1.06 1.06l1.47 1.47-1.47 1.47a.75.75 0 1 0 1.06 1.06l1.47-1.47 1.47 1.47a.75.75 0 1 0 1.06-1.06l-1.47-1.47 1.47-1.47a.75.75 0 0 0-1.06-1.06L11.5 9.44l-1.47-1.47z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormula);
export default ForwardRef;